import { FC, useEffect } from 'react';
import { SuccessToastProps } from './successModal.type';
import ActiveCheck from '../../assets/active_check.png';
import ErrorCross from '../../assets/error_cross.png';
import close from '../../assets/close_icon.png';
import './successModal.css';
import { getIdAttributes } from '../../utils/helper';

const SuccessToast: FC<SuccessToastProps> = (props) => {
  const idPrefix: string = 'success-modal';
  useEffect(() => {
    const timer: ReturnType<typeof setTimeout> = setTimeout(() => {
      props.onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [props.onClose]);

  return (
    <div
      className={`fixed bottom-10 w-[340px] right-10 px-8 py-8 rounded-2xl shadow-lg text-sm bg-green-50 text-[#000000] transition-all flex items-center justify-between; ${props.className}`}
      {...getIdAttributes(idPrefix, 'container')}
    >
      <img
        src={close}
        alt="Close Icon"
        className="close-icon"
        onClick={props.onClose}
        data-testid={props.closeTestId}
      />

      <div className="message-container">
        {props.showError ? (
          <img src={ErrorCross} alt="Cross Error" className="w-5 h-5 mr-2" />
        ) : (
          <img src={ActiveCheck} alt="Active Check" className="w-5 h-5 mr-2" />
        )}

        <span>{props.message}</span>
      </div>
    </div>
  );
};

export default SuccessToast;
